import { render, staticRenderFns } from "./form-unsubscribe.vue?vue&type=template&id=998fb3ce&"
import script from "./form-unsubscribe.vue?vue&type=script&lang=js&"
export * from "./form-unsubscribe.vue?vue&type=script&lang=js&"
import style0 from "./form-unsubscribe.vue?vue&type=style&index=0&id=998fb3ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports